var __rspack_ns_object = JSON.parse('{"No results.":"لا توجد نتائج.","Not enough room to display this column":"لا توجد مساحة كافية لعرض هذا العمود"}')